module.exports = __webpack_public_path__ + "img/pencil-filter-left_en.1a7523a.jpg";